import { ref } from 'vue'
import { defineStore } from 'pinia'
import { fetchMeterScans } from '@/api/endpoints'
import { useAuthStore } from '@/stores/auth'

/**
 * Wie viele ausgewertete Zählerfotos auf Prüfung warten.
 *
 * Ein eigener Endpunkt wäre Verschwendung: die Collection nennt die Gesamtzahl
 * schon im `totalItems`, eine Seite mit einem Eintrag genügt als Frage.
 */
export const useMeterScanQueueStore = defineStore('meterScanQueue', () => {
  const reviewCount = ref(0)
  const loading = ref(false)

  function canSee(): boolean {
    const auth = useAuthStore()
    return auth.isAuthenticated && auth.isAdmin && auth.canAccessApp('hausverwaltung')
  }

  async function refresh(): Promise<number> {
    if (!canSee()) {
      reviewCount.value = 0
      return 0
    }

    if (loading.value) return reviewCount.value

    loading.value = true
    try {
      const { totalItems } = await fetchMeterScans({ status: 'review', itemsPerPage: 1 })
      reviewCount.value = totalItems
    } catch (error) {
      // Der Badge ist Beiwerk — ein Fehler hier darf keine Seite stören.
      console.error('Prüf-Queue konnte nicht gezählt werden.', error)
    } finally {
      loading.value = false
    }

    return reviewCount.value
  }

  /** Nach dem Übernehmen oder Verwerfen, ohne auf den nächsten Poll zu warten. */
  function setCount(count: number) {
    reviewCount.value = Math.max(0, count)
  }

  return { reviewCount, loading, refresh, setCount }
})
